// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FullParcelIcon: 'full-parcel-icon',
	CircleCheckIcon: 'circle-check-icon',
	CircleExclamationIcon: 'circle-exclamation-icon',
	ClockIcon: 'clock-icon',
	LawyerClerkInitials: 'lawyer-clerk-initials',
	LawyerClerkInitials1: 'lawyer-clerk-initials-1',
	LawyerClerkInitials2: 'lawyer-clerk-initials-2',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
